import classNames from 'classnames'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { IHeaderGroup } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import React, { ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { IColumn } from './types'

import styles from './StyledTable.module.scss'

interface IProps<T> {
  columns: IColumn<T>[]
  className?: string
  headerGroups?: IHeaderGroup[]
}

const getThContent = (title?: string, titleRenderFn?: () => ReactNode) => {
  if (title) {
    return <Translation text={title} />
  }
  if (titleRenderFn) {
    return titleRenderFn()
  }
  return null
}
export function Header<T>({ columns, className, headerGroups }: IProps<T>) {
  return (
    <thead>
      <RenderWhen condition={Boolean(headerGroups)}>
        <tr className={classNames(styles.header, styles.headerGroups, className)}>
          {(headerGroups || []).map((group, index) => {
            return (
              <th
                key={index}
                colSpan={group.colspan}
                className={classNames({ [styles.noneBorder]: group.withoutBorder })}
              >
                {group.name}
              </th>
            )
          })}
        </tr>
      </RenderWhen>
      <tr className={classNames(styles.header, className)}>
        {columns.map((el, index) => {
          return (
            <th className={styles.thColumn} key={index}>
              {getThContent(el.title, el.titleRenderFn)}
            </th>
          )
        })}
      </tr>
    </thead>
  )
}
